import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'

import { useEffect, useMemo } from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import { transposeArrayType } from 'src/Libs/flow/utils/transpose-array-type'
import { WallboxHardware } from '@e3dc-react/shell/Libs/EMobility/wallboxes/models/wallbox-hardware.model'
import { usePortalQuery } from 'src/Libs/api'

type UseStorageWallboxes = {
  wallboxes: WallboxHardware[]
  isWallboxesLoading: boolean
  isWallboxesError: boolean
}

export function useStorageWallboxes(storageDeviceId: string | null, enabled = true): UseStorageWallboxes {
  const authFetch = useAuthFetchWithResult()
  const refresh = useTypedSelector(state => state.apiView.refresh)

  const {
    data,
    error,
    isLoading: isWallboxesLoading,
    isError: isWallboxesError,
  } = usePortalQuery({
    queryKey: ['storageWallboxes', storageDeviceId, refresh],
    queryFn: async () => {
      const res = await authFetch<ArrayType<WallboxHardware>>({
        path: `wallboxes/${storageDeviceId}`,
      })

      return transposeArrayType(res)
    },
    enabled: Boolean(storageDeviceId) && enabled,
  })

  useEffect(() => {
    if (isWallboxesError) {
      console.error(error)
    }
  }, [isWallboxesError, error])

  const wallboxes = useMemo(() => data || [], [data])

  return {
    wallboxes,
    isWallboxesLoading,
    isWallboxesError,
  }
}
